<template>
  <section>
    <review-form
      ref="reviewForm"
      :building_item="building_item"
      v-on:show-modal="showBuildingList"
      v-on:close-modal="closeModal"
      v-on:success-store="successReview"
    ></review-form>
    <building-modal v-if="ShowModal"
        v-on:select-building="selectBuilding"
    ></building-modal>
    <success-modal ref="successModal"></success-modal>
  </section>
</template>
<script>
import ReviewForm from './components/form'
import BuildingModal from "./components/building-modal";
import SuccessModal from "./components/successModal";
  export default {
    components: {
      'ReviewForm': ReviewForm,
      'BuildingModal':BuildingModal,
      'SuccessModal': SuccessModal,
    },
    data(){
      return {
        ShowModal:true,
        building_item:{
          name:'',
          id:null,
        },
      }
    },
    methods: {
      showBuildingList() {
        this.ShowModal = true;
        let vm =this;
        this.$nextTick(function () {
          $(function () {
            $('#reviewModal').modal('show')
          })

        })
      },
      successReview() {

        this.building_item = {
          name:'',
          id:null,
        }
        this.$refs.successModal.showSuccessModal();
      },
      selectBuilding(building) {
        this.building_item = building;
        this.$refs.reviewForm.getBuildingId(building.id);
        this.closeModal();
      },
      closeModal() {
        $('#reviewModal').modal('hide');
        let vm =this;
        $('#reviewModal').on('hidden.bs.modal', function (e) {
          vm.ShowModal = false;
        })
      }
    }
  }
</script>